import React, { useEffect, useState } from 'react';
import useDebounce from '../hooks/useDebounce';
import useUpdateEffect from '../hooks/useUpdateEffect';
import { updateData } from '../utils/filterHelperFunctions';
import { RiFilter3Fill } from 'react-icons/ri';
import { RxCross2 } from 'react-icons/rx';
import ObjectDropDown from 'lib/reusable-components/Components/DropDowns/ObjectDropDown';
import { dateConditionData, defaultDateArray } from '../data/defaultFilterSchema';
import { mls } from 'lib/multilanguagesupport';
import DatePicker from '../DatePicker';

interface filterItemsDATEProps {
  elem: any;
  selectedColumns: any[];
  index: number;
  setSelectedColumns: (columns: any[]) => void;
  handleRemoveColumnSelection: (elem: any) => void;
}
const FilterItemsDATE = ({
  elem,
  selectedColumns,
  index,
  setSelectedColumns,
  handleRemoveColumnSelection,
}: filterItemsDATEProps) => {
  const [selectedData, setSelectedData] = useState(elem?.value || defaultDateArray[4]);
  const [conditionData, setConditionData] = useState(
    elem?.value?.condition ?? dateConditionData.equals.key
  );
  const debounceValue = useDebounce(selectedData);
  const handleConditon = (action: any) => {
    setConditionData(action);
  };
  useUpdateEffect(() => {
    const value = { ...selectedData, condition: conditionData };
    const getData = updateData(selectedColumns, index, value);
    setSelectedColumns(getData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceValue]);

  useEffect(() => {
    setSelectedData(elem?.value ?? defaultDateArray[4]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [`${elem?.columnName}.${elem?.tableName}`]);

  return (
    <div className='containerItems'>
      <div className='Title'>
        <div className='filterIcon'>
          <RiFilter3Fill />
        </div>
        <div className='titleName'>{elem.name}</div>
        <div className='removeFilter' onClick={() => handleRemoveColumnSelection(elem)}>
          <RxCross2 />
        </div>
      </div>
      <div className='titleDiv'>{mls('Condition')}</div>
      <ObjectDropDown
        object={dateConditionData}
        dropDownValue={conditionData ?? dateConditionData.equals.key}
        setdropDownValue={handleConditon}
        ObjectInObject
      />
      <div className='titleDiv'>{mls('Value')}</div>
      <DatePicker dateData={selectedData} setDateData={setSelectedData} />
    </div>
  );
};

export default FilterItemsDATE;
